import styled from '@emotion/styled'
import { Skeleton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { AssetData } from 'constants/assets'
import { useState } from 'react'

const BlankToken = styled(Box)<{ size: number }>`
  background-color: #4c4c4c80;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 25px;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;
`

type Props = {
  assetData?: AssetData // Asset
  size: number
  withName?: boolean
  fontBold?: boolean
}

export default function CoreToken({
  assetData,
  size,
  withName = false,
  fontBold,
}: Props) {
  const [imgError, setImgError] = useState<boolean>(false)
  if (!assetData) {
    return <Skeleton variant="circular" width={size} height={size} />
  } else {
    const logoSrc = assetData.imgSrc

    return (
      <Box display="flex" alignItems="center" gap={1}>
        {!imgError && logoSrc ? (
          <img
            width={size}
            height={size}
            src={logoSrc}
            alt={`token-grid-${assetData.symbol}`}
            onError={() => setImgError(true)}
          />
        ) : (
          <BlankToken size={size}>
            <Typography variant="h5" sx={{ fontSize: `${size * 0.9}px` }}>
              {assetData.symbol[0]}
            </Typography>
          </BlankToken>
        )}
        {withName && (
          <Typography
            variant="body1"
            color="text.primary"
            fontWeight={fontBold ? 600 : 400}
          >
            {assetData.symbol}
          </Typography>
        )}
      </Box>
    )
  }
}
